import React from 'react';
import { useSelector } from 'react-redux';
import BasicDashboard from './dashboard/basic';
import StandardDashboard from './dashboard/standard';

const Dashboard = () => {
  let patient_type = useSelector((state) => state.patient.patientType);
  
  if (patient_type === undefined || !patient_type || patient_type === null) {
    return <BasicDashboard />
  }

  if (patient_type.toLowerCase() === 'basic') {
    return <BasicDashboard />;
  } else {
    return <StandardDashboard />;
  }
};

export default Dashboard;
